export default {
    BPA_CONSOLIDADO: '01',
    BPA_INDIVIDUALIZADO: '02',
    RAAS_ATENCAO_PSICOSSOCIAL: '09',
}